export const LANDING = {
  hero: "landing-hero",
  wordmark: "landing-wordmark",
  tagline: "landing-tagline",
  phoneMockup: "landing-phone-mockup",
  langToggle: "landing-lang-toggle",
  scrollToForm: "landing-scroll-to-form",

  formSection: "access-form-section",
  form: "access-form",
  fullName: "access-form-fullname",
  email: "access-form-email",
  linkedin: "access-form-linkedin",
  profile: "access-form-profile",
  invitationCode: "access-form-invitation-code",
  message: "access-form-message",
  submit: "access-form-submit",

  successCard: "access-form-success",
  errorMessage: "access-form-error",
};
